import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/navigation';
import { toast } from 'react-toastify';
import { Button } from '@innovationnorway/cl-react';
import { useSivaGoalsDetails } from '../../hooks/use-siva-goals-details';

type Props = {
  clusterId: string;
  year: number;
  hasBeenReviewed?: boolean;
  sivaHasCommented: boolean;
  setWantsToReviseReview: React.Dispatch<React.SetStateAction<boolean>>;
};

const SivaGoalsReviewButtons: React.FC<Props> = ({
  clusterId,
  year,
  hasBeenReviewed,
  sivaHasCommented,
  setWantsToReviseReview,
}) => {
  const navigate = useNavigate();

  const { mutations } = useSivaGoalsDetails(clusterId, year);

  const handleApproveGoals = async () => {
    if (!year || !clusterId) {
      toast.error('Finner ikke år og aktør id. Vennligst prøv igjen senere.');
      return;
    }

    try {
      await mutations.approve.mutateAsync();
      navigate(ROUTES.SIVA.ADMIN.GOALS.YEAR(year).DETAILS(clusterId).CONFIRMATION);
    } catch (err) {
      console.error(err);
      toast.error('Kunne ikke godkjenne måltall. Vennligst prøv igjen senere.');
    }
  };

  const handleRejectGoals = async () => {
    if (!year || !clusterId) {
      toast.error('Finner ikke år og aktør id. Vennligst prøv igjen senere.');
      return;
    }

    try {
      await mutations.reject.mutateAsync();
      navigate(ROUTES.SIVA.ADMIN.GOALS.YEAR(year).DETAILS(clusterId).CONFIRMATION);
    } catch (err) {
      console.error(err);
      toast.error('Kunne ikke sende tilbake måltall. Vennligst prøv igjen senere.');
    }
  };

  if (hasBeenReviewed) {
    return (
      <Button type="button" variant="secondary" onClick={() => setWantsToReviseReview(true)}>
        Ønsker du å endre vurderingen?
      </Button>
    );
  }

  return (
    <div className="display--flex gap--2">
      <Button type="button" onClick={handleApproveGoals} loading={mutations.approve.isLoading}>
        Godkjenn
      </Button>

      <Button
        type="button"
        variant="secondary"
        onClick={handleRejectGoals}
        loading={mutations.reject.isLoading}
        disabled={!sivaHasCommented}
        title="Kommenter på minst en henvendelse for å be aktøren gjøre endringer."
      >
        Send tilbake med kommentarer
      </Button>
    </div>
  );
};

export default SivaGoalsReviewButtons;
